import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=1e33704c&scoped=true&"
import script from "./Robot.vue?vue&type=script&lang=js&"
export * from "./Robot.vue?vue&type=script&lang=js&"
import style0 from "./Robot.vue?vue&type=style&index=0&id=1e33704c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e33704c",
  null
  
)

export default component.exports